<template>
  <div class="has-navbar-fixed-top">
    <nav class="navbar is-fixed-top"><SideMenu></SideMenu>
      <h1 class="title">FAQs</h1>
    </nav>
    <section class="section">
      <div class="container">
        <div class="content">
          <p class="question">How long will <i>These Pages Fall Like Ash</i> take to read?</p>
          <p class="answer">It’s up to you. There’s an interval between each of the three episodes, but it’s up to you
          how long that is. Minutes, hours, or days. But the next episode will be waiting for you if
          you’re busy.</p>
          <p class="question">Is there a minimum system requirement?</p>
          <p class="answer">As long as you have a working web browser on your phone, a data connection and GPS - you’ll be fine.</p>
          <p class="question">Is this work appropriate for someone under 18?</p>
          <p class="answer">We took out the one swear word from the first edition, so yes. You can walk the piece with them too. It’s designed to be read - as a book is - by yourself, but there’s no reason you can’t walk it with someone else.</p>
          <p class="question">My phone won’t recognise locations - help!</p>
          <p class="answer">Check you have Location Services turned on and have allowed access for both your browser and this website in your settings. If there’s still a problem, email <a href="mailto:support@pagesfall.com">support@pagesfall.com</a> and we’ll see what we can do.</p>
          <p class="question">This is great! Have you made anything else?</p>
          <p class="answer">Thankyou! Check out <a href="https://ambientlit.com">ambientlit.com</a> for more projects. We made the first edition of <i>These Pages Fall Like Ash</i> in 2013, and in between then and now have been hard at work exploring ways in which your phone can be a medium for telling stories.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {

  name: 'FAQs',

  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  text-align: left;
  .question {
    font-weight: bold;
    margin-bottom: 5px;
  }
  .answer {
    margin-bottom: 2em;
    padding-left:1em;
  }
}
.header {
  text-align: center;
}
.has-navbar-fixed-top {
  padding-top: 3em;
}
nav h1 {
  padding: 26px 0 10px 0;
  left: 0px;
  right: 0px;
  margin:auto;
}

</style>
